define('home/views/ChannelsModuleItemView',[
    'backbone-marionette',

    'home/templates/channelsModuleItem',
], function (
    Marionette,

    channelsModuleItemTemplate
) {
    'use strict';

    /**
     * Shows a single channel in a module.
     * Expects a Channel model.
     */
    var ChannelsModuleItemView = Marionette.ItemView.extend({
        template: channelsModuleItemTemplate,
    });

    return ChannelsModuleItemView;
});

